module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "western2",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "c"
  }, [_c('a', {
    attrs: {
      "href": "http://www.permutedpress.com/",
      "target": "_blank"
    }
  }, [_vm._v("PERMUTED PRESS")])]), _vm._v(" book")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("published at Smashwords.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("ISBN (trade paperback): 978-1-61868-106-5")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("ISBN (eBook): 978-1-61868-107-2")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("Blood Soaked and Contagious")]), _vm._v(" copyright\n© 2011, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("by James Crawford.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("All Rights Reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_vm._v("Cover design by Karen Fletcher")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western5"
  }, [_vm._v("This book is a work of fiction. People,\nplaces, events, and situations are the product of the author’s\nimagination. Any resemblance to actual persons, living or dead, or\nhistorical events, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western5"
  }, [_vm._v("No part of this book may be reproduced,\nstored in a retrieval system, or transmitted by any means without\nthe written permission of the author and publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western5"
  }, [_vm._v("Version 3.30.13.1.")]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western3"
  }, [_c('img', {
    staticClass: "calibre5",
    attrs: {
      "alt": "tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_1467a33.png",
      "id": "Picture_4",
      "src": "tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_1467a33.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad72ee0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue
// module id = 66
// module chunks = 0